import { useEffect, useState } from 'react'
import { Box, Button, Checkbox, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from '@mui/material'
import { PermissionWrapper } from '../../../wrappers'
import NoRecordFound from '../../../shared_elements/NoRecordFound'
import { trackActivity } from '../../../utils/mixpanel'
import GenerateSummaryInvoice from '../components/GenerateSummaryInvoice'
import { SummaryInvoiceList } from '../components'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { getDeleteInvoicePayload, getDeleteInvoicePopUpProps } from '..';
import { STableLoader, DeletePopUp, Pagination, FilterComponent, PageLoader, jetstreamAvi, gaTelesisInstance, jetStreamInstance, hanwahaInstance } from '../../../shared_elements'
import { getSummaryInvoiceApi, getAssetListApi, getSummaryExportApi, getInvoiceAuthUrl, getInvoiceApprovalReportApi } from '../apiService'
import { getStorage } from '../../../shared_elements/actionCreators'
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices'
import { checkApiStatus, setGlobalCookie, getGlobalCookie } from '../../../utils'
import { enqueueSnackbar } from 'notistack'
import { getQbStatusApi } from '../../quickBooks/apiService'
import ChangeSummaryInvStatus from '../components/ChangeSummaryInvStatus'
import RevisionHistory from '../../../shared_elements/components/RevisionHistory'
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory'

const invoiceStatusOptions = [
	{ label: 'Draft', value: 1 },
	{ label: 'Sent', value: 2 },
	{ label: 'Paid', value: 3 },
	// { label: 'Cancelled', value: 4 },
	{ label: 'Partially-Paid', value: 5 },
    ...(jetstreamAvi ? [{ label: 'Updated', value: 6 }] : []),
];

const invoiceTypeOptions = [
	{ label: 'Reserve', value: 1 },
	{ label: 'Rental', value: 2 },
];

const InvoicesHd = ({ sortInfo, createSortHandler, isQbEnabled, selectedCount, selectableCount, onSelectAll }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Fleet Invoices`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {isQbEnabled && (
                            <Checkbox
                                size="small"
                                checked={selectableCount > 0 && selectedCount === selectableCount}
                                disabled={selectableCount === 0}
                                onChange={onSelectAll}
                            />
                        )}
                        Action(s)
                    </Box>
                </TableCell>
                <TableCell sx={{ minWidth: '110px' }}> Asset </TableCell>
                <TableCell sx={{ minWidth: '140px' }}> {tableSorting('invoice_number', 'Invoice Number')}</TableCell>
                <TableCell sx={{ minWidth: "110px" }}>{tableSorting('lessor', 'Lessor/Holdco')}</TableCell>
                <TableCell sx={{ minWidth: "110px" }}>{tableSorting('lessee', 'Lessee')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('date', 'Invoice Date')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('due_date', 'Due Date')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('period', 'Invoice Period')}</TableCell>
                <TableCell sx={{ minWidth: '120px' }}> {tableSorting('status', 'Status')}</TableCell>
                <TableCell sx={{ minWidth: '120px' }}> {tableSorting('amount', 'Amount')}</TableCell>
            </TableRow>
        </TableHead>
    );
};

const SummaryInvoices = () => {
    const [generateSummary, setGenerateSummary] = useState(false)
    const { currencies, owner, lessee } = useSelector((state) => state.leases);
	const dispatch = useDispatch();
	const params = useParams();
	const [isLoading, setLoading] = useState(false);
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [invoicesInfo, setInvoicesInfo] = useState({ summaries: [], pagination: {} });
	const [deleteInvoices, setDeleteInvoices] = useState({ modal: false, item: {}, data: { ids: [] } })
	const [sortInfo, setSortInfo] = useState({ sort: 'desc', sort_by: gaTelesisInstance ? 'period' : 'date' });
	const [filter, setFilter] = useState({});
	const [changeInvStatus, setChangeInvStatus] = useState({ modal: false, data: null });
	const [assetList, setAssetList] = useState([]);
	const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
	const [isBulkExport, setIsBulkExport] = useState(false);
	const [isQbEnabled, setIsQbEnabled] = useState(false);
	const [selectedSummaries, setSelectedSummaries] = useState([]);
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Fleet Invoices', page_type })
    }

    const fleetInvoiceFilterMenu = {
            asset_id: { title: 'Asset', inputType: 'dropdown', options: assetList || [], valueKey: 'id', labelKey: 'name', multiple: true },
            invoice_number: { title: 'Invoice Number', inputType: 'text' },
            invoice_type: { title: 'Invoice Type', inputType: 'dropdown', options: invoiceTypeOptions, valueKey: 'value', labelKey: 'label', multiple: true },
            status: { title: 'Status', inputType: 'dropdown', options: invoiceStatusOptions, valueKey: 'value', labelKey: 'label', multiple: true },
            lessor_id: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: true },
            lessee_id: { title: 'Lessee', inputType: 'dropdown', options: lessee || [], valueKey: 'id', labelKey: 'name', multiple: true },
            invoice_start_date: { title: 'Invoice Date (Start Range)', inputType: 'date' },
            invoice_end_date: {title: 'Invoice Date (End Range)', inputType: 'date'},
            due_date: { title: 'Due Date', inputType: 'date' },
            overdue_days: { title: "Overdue Days", inputType: "number"},
            start_date: { title: 'Period Start Date', inputType: 'date' },
            end_date: { title: 'Period End Date', inputType: 'date' },
            payment_start_date: {title: 'Payment Start Date', inputType: 'date'},
            payment_end_date: {title: 'Payment End Date', inputType: 'date'},
            currency: { title: 'Currency', inputType: 'dropdown', options: currencies || [], valueKey: 'code', labelKey: 'name', multiple: true, },
        };
    
        useEffect(() => {
            getSummaryInvoices('skeletonLoader', { per_page: 50, sort_by: sortInfo.sort_by, sort: sortInfo.sort });
            getAssetList();
            trackActivity('Page Viewed',{ page_title: 'Fleet Invoices'});
            globalGetService(getQbStatusApi()).then(response => {
                if (checkApiStatus(response)) setIsQbEnabled(response.data.data?.is_lessor_enabled || false);
            });
        }, [dispatch]);

        const getAssetList = () => {
            globalGetService(getAssetListApi({ is_invoice: true })).then(response => {
                if (checkApiStatus(response)) {
                    setAssetList(response?.data?.data);
                }
            });
        };

        const getSummaryInvoices = (loaderType, query = {}) => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
            globalGetService(getSummaryInvoiceApi(query)).then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setInvoicesInfo(response?.data?.data);
                }
            });
            dispatch(getStorage({module_name:"invoices"}));
        }
    
        const createSortHandler = (key) => {
            let sortQuery = { sort_by: key }
            if (sortInfo.sort_by === key) {
                sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
            } else {
                sortQuery = { ...sortQuery, sort: 'asc' }
            }
            setSortInfo(sortQuery);
            setSelectedSummaries([]);
            getSummaryInvoices('', {
                ...filter,
                ...sortQuery,
                page: invoicesInfo?.pagination?.page || 1,
                per_page: invoicesInfo?.pagination?.per_page || 50,
            });
        }

        const onApplyFilter = (query) => {
            setFilter(query);
            setSelectedSummaries([]);
            getSummaryInvoices('', { ...query, page: 1, per_page: invoicesInfo?.pagination?.per_page || 50 });
        }

        const canSelectSummary = (item) => {
            if (!isQbEnabled) return false;
            if (hanwahaInstance) {
                if (item?.status?.value === 1) return false;
                if (item?.qb_sync_required !== true) return false;
                return true;
            }
            if (item?.status?.value !== 2) return false;
            if (item?.qb_last_sync_by) return false;
            return true;
        };

        const selectableInCurrentPage = invoicesInfo?.summaries?.filter(canSelectSummary) || [];
        const selectedInCurrentPage = selectableInCurrentPage.filter(inv => selectedSummaries.some(s => s.slug === inv.slug));

        const onToggleSelectSummary = (item) => {
            setSelectedSummaries(prev => {
                const alreadySelected = prev.some(inv => inv.slug === item.slug);
                return alreadySelected ? prev.filter(inv => inv.slug !== item.slug) : [...prev, item];
            });
        };

        const onSelectAll = () => {
            if (selectedInCurrentPage.length === selectableInCurrentPage.length) {
                setSelectedSummaries(prev => prev.filter(inv => !selectableInCurrentPage.some(s => s.slug === inv.slug)));
            } else {
                const toAdd = selectableInCurrentPage.filter(inv => !selectedSummaries.some(s => s.slug === inv.slug));
                setSelectedSummaries(prev => [...prev, ...toAdd]);
            }
        };
    
        const onDeleteInvoice = () => {
            setLoading(true);
            globalDeleteService(getSummaryInvoiceApi(params), getDeleteInvoicePayload(deleteInvoices?.data))
                .then(response => {
                    if (checkApiStatus(response)) {
                        trackActivity('Item Deleted', { page_title: `Delete Fleet Invoice`, success_msg: response?.data?.message, item_ids: deleteInvoices?.data, qb_synced: !!deleteInvoices?.data?.qb_last_sync_by, response: response?.data })
                        setDeleteInvoices({ modal: false, data: null });
                        getSummaryInvoices('', { page: invoicesInfo?.pagination?.page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 });
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Deleted', { page_title: `Delete Fleet Invoice`, error_msg: response?.data?.message, item_ids: deleteInvoices?.data, response: response?.data })
                    }
                })
        }

        const handleSummaryReport = () => {
            setLoading(true);
            globalGetService(getInvoiceApprovalReportApi({ file_type: 'xlsx' })).then((response) => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
            });
        }
        const handleExport = () => {
                let query = { ...filter, export: true,}
                if (sortInfo?.sort && sortInfo?.sort_by) {
                    query = {
                        ...query,
                        sort: sortInfo?.sort,
                        sort_by: sortInfo?.sort_by
                    }
                }
                 setIsBulkExport(true);
                globalGetService(getSummaryExportApi(query)).then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar( response?.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } } );
                        setIsBulkExport(false);
                    }
                    else {
                        enqueueSnackbar( response?.data.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } } );
                        setIsBulkExport(false);
                    }
                })
            }


    const syncSummaryInvoicesToQb = () => {
        const slugs = selectedSummaries.map(inv => inv.slug).join(',');
        setLoading(true);
        globalGetService(getInvoiceAuthUrl({ summary_invoice_slug: slugs })).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyInvoiceState', 'SyncInvoiceFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    const syncSummaryFromQb = () => {
        setLoading(true);
        globalGetService(getInvoiceAuthUrl({})).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyInvoicePullState', 'SyncInvoicePullFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    const jetstreamAvi = JSON.parse(getGlobalCookie("lessorAccess")).id === 442;
    return (
        <>
            <Paper elevation={2} square sx={{ padding: '5px', mt: '-10px' }} className="active-asset-header">
                <Grid container spacing={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Grid size='grow' sx={{ minWidth: 0 }}>
                        {!skeletonLoader ? <FilterComponent filter={filter} filterMenu={fleetInvoiceFilterMenu} getResponseBack={onApplyFilter} /> : null}
                    </Grid>
                    <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ul className="list-inline">
                            <li className='lease-mobile-button revision-history' style={{ marginRight: '5px' }}>
								<ModuleWiseRevisionHistory ViewGlobalHistory={() => { setRevisionHistory({ modal: true, mode: '', data: { type: "global" } }); handleItemClicked('Global Revision HistoryIcon') }} />
							</li>
                            {isQbEnabled && invoicesInfo?.summaries?.length > 0 && (
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                    {jetStreamInstance ?
                                    <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                        <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { syncSummaryFromQb(); handleItemClicked('Sync from QB Button') }}>Sync from QB</Button>
                                    </li> : null}
                                    <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                        <Tooltip title={selectedSummaries.length === 0 ? 'Select Send status invoices to sync' : ''} arrow>
                                            <span>
                                                <Button variant="contained" color="primary" size='small' className='btn-primary' disabled={selectedSummaries.length === 0} onClick={() => { syncSummaryInvoicesToQb(); handleItemClicked('Sync to QB Button') }}>
                                                    Sync to QB {selectedSummaries.length > 0 ? `(${selectedSummaries.length})` : ''}
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </li>
                                </PermissionWrapper>
                            )}
                            {jetstreamAvi &&
                                <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                    <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { handleSummaryReport(); handleItemClicked('Approval Report Button') }}>Approval Report</Button>
                                </li>
                            }
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['EXP'] }}>
                                {invoicesInfo?.summaries?.length > 0 ? (
                                    <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                        <Button
                                            disabled={isBulkExport || skeletonLoader}
                                            onClick={() => { handleExport(); handleItemClicked('Bulk Export Button') }}
                                            variant="contained"
                                            size="small"
                                            color="primary"
                                            endIcon={isBulkExport ? <CircularProgress size={14} color="inherit" /> : null}
                                        >
                                            Bulk Export
                                        </Button>
                                    </li>
                                ) : null}
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'invoices', operationType: ['C'] }}>
                                <li className="list-inline-item">
                                    <Button
                                        size='small'
                                        variant='contained'
                                        color='primary'
                                        disabled={skeletonLoader}
                                        onClick={() => { setGenerateSummary(true); handleItemClicked('Generate Summary Invoice') }}
                                    >
                                        Generate Summary Invoice
                                    </Button>
                                </li>
                            </PermissionWrapper>
                        </ul>
                    </Grid>
                </Grid>
            </Paper>
            <Paper className="active-asset-list" square>
                {skeletonLoader ? <STableLoader count={6} rowCount={9} /> :
                    <div className="fleet-inv-content" style={{ maxHeight: `${window.innerHeight - 360}px`, overflow: "auto", boxSizing: 'border-box' }}>
                        <Table className="mui-table-format" stickyHeader>
                            <InvoicesHd
                                sortInfo={sortInfo}
                                createSortHandler={createSortHandler}
                                isQbEnabled={isQbEnabled}
                                selectedCount={selectedInCurrentPage.length}
                                selectableCount={selectableInCurrentPage.length}
                                onSelectAll={onSelectAll}
                            />
                            <TableBody>
                                {invoicesInfo?.summaries?.length > 0 && invoicesInfo?.summaries?.map((item, index) => (
                                    <SummaryInvoiceList
                                        key={index}
                                        item={item}
                                        onDelete={() => setDeleteInvoices({ modal: true, data: item })}
                                        onView={() => {
                                            sessionStorage.setItem("invoiceViewFrom", "viewFromSummary");
                                            window.open(`/summary-invoices/${item?.slug}`, "_blank");
                                        }}
                                        onInvStatus={() => setChangeInvStatus({ modal: true, data: item })}
                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                        isQbEnabled={isQbEnabled}
                                        isSelected={selectedSummaries.some(s => s.slug === item.slug)}
                                        canSelect={canSelectSummary(item)}
                                        onToggleSelect={() => onToggleSelectSummary(item)}
                                    />
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                }
                {!skeletonLoader && invoicesInfo?.summaries?.length === 0 ? <NoRecordFound /> : null}
                <Pagination
                    pagination={invoicesInfo?.pagination}
                    onPageChange={(event, newPage) => { getSummaryInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: newPage + 1, per_page: invoicesInfo?.pagination?.per_page }); }}
                    onRowsPerPageChange={(e) => { getSummaryInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: 1, per_page: e.target.value }); }}
                />
            </Paper>
            {deleteInvoices.modal && (
                <DeletePopUp
                    modal={deleteInvoices.modal}
                    title={'Delete Summary Invoice'}
                    onDeleteRecords={() => onDeleteInvoice()}
                    {...getDeleteInvoicePopUpProps(deleteInvoices?.data)}
                    onToggleModal={() => setDeleteInvoices({ modal: false, data: null })}
                />
            )}
            {changeInvStatus.modal && (
                <ChangeSummaryInvStatus
                    invoiceStatus={changeInvStatus}
                    invoiceType={changeInvStatus?.data?.invoice_type?.name}
                    onToggleModal={() => setChangeInvStatus({ modal: false, data: null })}
                    getResponseBack={() => getSummaryInvoices('', { page: invoicesInfo?.pagination?.page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 })}
                />
            )}
            <GenerateSummaryInvoice
                generateSummary={generateSummary}
                setGenerateSummary={setGenerateSummary}
                getResponseBack={() => getSummaryInvoices('pageLoader', { page: 1, per_page: invoicesInfo?.pagination?.per_page || 50 })}
            />
            {isLoading ? <PageLoader /> : null}
            {revisionHistory.modal &&
                <RevisionHistory
                    moduleName="summary_invoice"
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
        </>
    )
}

export default SummaryInvoices
